import React, { useEffect, useRef, useState } from "react";
import ServiceProgramCard from "../../../../biblio/Cards/ServiceProgramCard";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { getDateRange, scroll } from "../../../../components/utils/utils";
import { Col, Row, Tabs } from "antd";
import Selects from "../../../../biblio/Selects/Selects";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import {
  toGetProgramsBeneficiary,
  toGetProgramsCategories,
} from "../../../../apis/actions/programs.actions";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import ProgramRequestCard from "../../../../components/card-request-beneficiary/ProgramRequestCard";
import CustomConfigProvider from "../../ProfileHeader";

const BeneficiaryPrograms = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { programs, loading, categories, TotalPrograms } = useSelector(
    (state: RootState) => state?.programs
  );

  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProgram, setSelectedProgram] = useState<any>();
  const [activeTab, setActiveTab] = useState<string>("available");
  const [state, setState] = useState({
    year: new Date().getFullYear().toString(),
    month: "",
  });
  const showModal = (card: any) => {
    setSelectedProgram(card);
  };

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [state]);
  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      toGetProgramsBeneficiary({
        tag: activeTab,
        limit: itemPerPage,
        page: currentPage,
        category_id: selectedFilter,
        date_from: date_from,
        date_to: date_to,
      })
    );
    dispatch(toGetProgramsCategories());
  }, [dispatch, activeTab, currentPage, selectedFilter, state]);

  const itemPerPage = 4;

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.value);
      setCurrentPage(1);
    } else {
      setSelectedFilter(null);
    }
  };

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    setCurrentPage(1); // Reset to the first page when changing tabs
  };

  const tabsData = [
    {
      key: "available",
      label: "متاح",
    },
    {
      key: "closed",
      label: "مغلق",
    },
    {
      key: "coming_soon",
      label: "قريبا",
    },
  ];
  return (
    <>
      <CustomConfigProvider
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
        title="البرامج"
        YearValue={state.year}
      >
        <Selects
          options={categories}
          selectPlaceholder="نوع البرنامج"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>

      <Tabs
        defaultActiveKey="available"
        activeKey={activeTab}
        onChange={handleTabChange}
        className="takaful--content-profile-tab takaful--registration beneficiary-programs"
        items={tabsData.map(({ key, label }) => ({
          key,
          label: (
            <Row style={{ width: "100%" }}>
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <div className="tab-label">
                  <span className="tab-label-text">{label}</span>
                </div>
              </Col>
            </Row>
          ),
          children: (
            <>
              {loading ? (
                <div
                  className="takaful--loading-projects-cases"
                  style={{ marginTop: "3rem" }}
                >
                  <p className="takaful--no-project-message"> جارٍ التحميل</p>
                  <DotsLoader />
                </div>
              ) : programs?.length === 0 && !selectedFilter ? (
                <div style={{ marginTop: "3rem" }}>
                  <p className="takaful--no-services ">لا توجد برامج</p>
                </div>
              ) : programs?.length === 0 && selectedFilter ? (
                <div style={{ marginTop: "3rem" }}>
                  <p className="takaful--no-services">
                    لا يوجد برامج تتوافق مع البحث الذي قمت به
                  </p>
                </div>
              ) : (
                <>
                  <Row
                    gutter={[64, 48]}
                    dir="rtl"
                    ref={currentRef}
                    style={{ marginTop: "3rem" }}
                  >
                    {programs.map((card: any, index: number) => (
                      <Col
                        key={index}
                        xxl={12}
                        xl={12}
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}
                      >
                        <ServiceProgramCard
                          card={card}
                          index={index}
                          type="internal"
                          open={() => showModal(card)}
                        />
                      </Col>
                    ))}
                  </Row>
                  <div className="takaful--pagination-container">
                    {programs &&
                      Math.ceil(TotalPrograms) * itemPerPage > itemPerPage && (
                        <PaginationComponent
                          active={currentPage}
                          total={Math.ceil(TotalPrograms) * itemPerPage}
                          itemPerPage={itemPerPage}
                          scroll={() => scroll(currentRef)}
                          setActive={(nb) => updateActive(nb)}
                        />
                      )}
                  </div>
                </>
              )}
            </>
          ),
        }))}
      />

      {selectedProgram && (
        <ModalComponent
          title={""}
          open={selectedProgram !== null}
          closeOnOutsideClick={true}
          onClose={() => setSelectedProgram(null)}
          width={600}
          centered={true}
          modalStyle={{ top: "-8rem" }}
        >
          <ProgramRequestCard
            program={selectedProgram}
            setSelectedProgram={() => {
              scroll(currentRef);
              setSelectedProgram(null);
            }}
          />
        </ModalComponent>
      )}
    </>
  );
};

export default BeneficiaryPrograms;
